import React from "react";

const legalLinks = [
  {
    section: "TERMS OF SERVICE",
    links: [
      { label: "Terms of Service – Consumer", href: "/terms-of-use" },
      { label: "Terms of Service – Enterprise", href: "coming-soon" },
    ],
  },
  {
    section: "POLICIES",
    links: [
      { label: "Acceptable Use Policy", href: "/acceptable-use-policy" },
      { label: "Privacy Policy", href: "/privacy-policy" },

      { label: "Cookie Policy", href: "/cookie-policy" },
    ],
  },
  {
    section: "OTHER",
    links: [
      { label: "FAQ – Consumer", href: "/coming-soon" },
      { label: "FAQ – Enterprise", href: "coming-soon" },
      { label: "Brand Guidelines", href: "/brand" },
    ],
  },
];

const ExternalIcon = () => (
  <svg
    className="w-4 h-4 inline-block ml-2 text-gray-400"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    viewBox="0 0 16 16"
    style={{ verticalAlign: "middle" }}
  >
    <path
      d="M4 12L12 4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M7.5 4H12V8.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const Legal = () => (
  <div className="min-h-screen bg-black text-white flex flex-col items-center py-12 px-4">
    <div className="w-full max-w-4xl mx-auto">
      <h1 className="text-5xl font-semibold font-primary mb-16 mt-2 text-left">
        Legal Policies
      </h1>
      <div className="text-sm text-gray-400 mb-6">
        Updated on 1st October, 2025
      </div>
      <div className="space-y-16">
        {legalLinks.map((section) => (
          <div
            key={section.section}
            className="flex flex-col md:flex-row md:items-start gap-8"
          >
            <div className="md:w-1/3 mb-4 md:mb-0">
              <div className="text-gray-400 tracking-widest text-sm font-mono uppercase">
                {section.section}
              </div>
            </div>
            <div className="flex-1 space-y-2 w-full">
              {section.links.map((link) => (
                <div
                  key={link.label}
                  className="flex items-center justify-between border-b border-gray-800 py-2 group"
                >
                  <a
                    href={link.href}
                    className="text-lg font-medium text-white hover:underline transition-colors duration-150"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {link.label}
                  </a>
                  <span className="ml-2 opacity-60 group-hover:opacity-100 transition-opacity duration-150">
                    <ExternalIcon />
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Legal;
